export default "__VITE_ASSET__5c99007b__"